import i18next from "../../i18n";
import { lazy } from "react";
import { getExactHiddenRoute, getExactRoute } from "util/react";

import EN from "./i18n/en.json";
import LT from "./i18n/lt.json";

i18next.addResourceBundle("en", "client", EN);
i18next.addResourceBundle("lt", "client", LT);

export const ClientCreateRoute = getExactHiddenRoute(
  "client",
  "menu.edit",
  "/client/new",
  lazy(() => import("./layout/ClientEditLayout")),
  null,
  ["admin"],
);
export const ClientEditRoute = getExactHiddenRoute(
  "client",
  "menu.edit",
  "/client/:id",
  lazy(() => import("./layout/ClientEditLayout")),
  null,
  ["admin"],
);
export const ClientListRoute = getExactRoute(
  "client",
  "menu.list",
  "/client",
  lazy(() => import("./layout/ClientListLayout")),
  null,
  ["admin"],
);

const ClientRoute = (
  <>
    {ClientListRoute}
    {ClientCreateRoute}
    {ClientEditRoute}
  </>
);

export default ClientRoute;
